import { get } from 'lodash';
import { observable, action } from 'mobx';
import { createContext } from 'react';
import { GlobalDocContentType } from '../types';
import { getNodeLevel, openTreeExpand, hasId } from '@/pages/document/utils';
import { getPlatConfig, getDocsList, getDocsContent } from '../server';
import i18next from 'i18next';
import Message from '@/component/Message';

const DefaultDocContent = {
  type: '',
  content: '',
  title: '',
};

class DocsStoreClass {
  @observable language = '';

  @observable activeDocId = 0;

  @observable identifyKey = '';

  @observable activeHash = '';

  @observable viewType = '';

  @observable docsTree: any = [];

  @observable isClickNav = false;

  // 文档配置信息
  @observable docConfig = null;

  // 文档树加载状态
  @observable docTreeStatus = 'loading';

  // 文档内容加载状态
  @observable docContentStatus = 'loading';

  @observable globalDocContent: GlobalDocContentType[] = [];

  @observable docContent = {
    ...DefaultDocContent,
  };

  @action
  resetDocContent() {
    this.docContent = {
      ...DefaultDocContent,
    };
  }

  @action
  async getDocsTree(identifyKey: string) {
    this.docTreeStatus = 'loading';
    const result = await getDocsList({ identifyKey, isNeedContent: this.viewType === 'GLOBAL', language: this.language });
    this.docTreeStatus = 'success';
    const list = get(result, 'data.primaryDocList', []);
    if (!this.activeDocId || !hasId(list, this.activeDocId)) {
      this.activeDocId = get(result, 'data.primaryDocList[0].docId', 0);
    }
    const index = getNodeLevel(list, this.activeDocId);
    this.docsTree = openTreeExpand(list, index, false);
    if (this.viewType === 'GLOBAL') {
      const docList: GlobalDocContentType[] = [];
      const loop = (data: any) => {
        data.forEach((item: any) => {
          docList.push({
            type: item.type,
            title: item.title,
            content: item.content,
            docId: item.docId,
          });
          if (item.childDocs && item.childDocs.length) {
            loop(item.childDocs);
          }
        });
      };
      loop(list);
      this.globalDocContent = docList;
    }
  }

  @action
  async getPlatConfig() {
    const config = {
      identifyKey: this.identifyKey,
      docId: this.activeDocId,
    };
    if (!this.activeDocId) {
      delete config.docId;
    }
    const result = await getPlatConfig(config);
    // 如果是当前文档有 docLanguage 则设置 活跃文档语言
    this.language = get(result, 'data.docLanguage', '') || this.language;
    this.activeDocId = get(result, 'data.docId', 0);
    this.viewType = get(result, 'data.viewType', 'SINGLE');
    this.docConfig = get(result, 'data.config', null);

    this.getDocsTree(this.identifyKey);
    if (result.code === 40001) {
      Message.error(i18next.t('doc_platform_not_found'));
    }
  }

  @action
  async getDocContent(docId: number) {
    this.docContentStatus = 'loading';
    const result = await getDocsContent({ identifyKey: this.identifyKey, docId, language: this.language });
    this.docContent = {
      type: get(result, 'data.type', ''),
      content: get(result, 'data.content', ''),
      title: get(result, 'data.title', ''),
    };
    // 延迟状态变化  页面变化更顺畅
    setTimeout(() => {
      this.docContentStatus = 'success';
    }, 0);
  }
}

export const DocsStoreInfo = new DocsStoreClass();
export const DocsStore = createContext(DocsStoreInfo);
